import React from "react";
import ReactDOM from "react-dom/client";
import "./style/index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { GlobalContextProvider } from "./context/ConversationsProvider";
import { AuthProvider } from "./context/AuthProvider";
import GoogleAnalytics from "./Components/Analytics/GoogleAnalytics";
import MicrosoftClarity from "./Components/Analytics/MicrosoftClarity";
import { ClientProvider } from "./context/ClientsProvider";

import MuiCustomTheme from "./style/theme/MuiCustomTheme";
import { ChatQueryClientProvider } from "./context/QueryClientProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <MuiCustomTheme>
    <BrowserRouter>
      <ChatQueryClientProvider>
        <AuthProvider>
          <GoogleAnalytics />
          <MicrosoftClarity />
          <ClientProvider>
            <GlobalContextProvider>
              <App />
            </GlobalContextProvider>
          </ClientProvider>
        </AuthProvider>
      </ChatQueryClientProvider>
    </BrowserRouter>
  </MuiCustomTheme>,
);
